import { AdditionalProtectionsModel, DefaultAdditionalProtections } from "./additionalProtections";
import { DefaultPolicyDuration, PolicyDurationId, PolicyDurationModel } from "./policyDuration";
import { addDays } from "date-fns";
import { DefaultPaymentMode, PaymentModeId, PaymentModeModel } from "./paymentMode";
import { TypeOfActivityId } from "./typeOfActivity";
import { ClaimlessYearsIn5YearsModel, DefaultClaimlessYearsIn5Years } from "./claimlessYearsIn5Years";
import { BusinessActivityModel, DefaultBusinessActivityInBuilding } from "./businessActivity";
import { DefaultPartOfFarm, PartOfFarmModel } from "./partOfFarm";
import {
  DefaultNumberOfDamagesInLastThreeYears,
  NumberOfDamagesInLastThreeYearsModel
} from "./numberOfDamagesInLastThreeYears";
import { makeObservable, observable } from "mobx";

export enum AdditionalQuestionsId {
  businessActivityInBuilding = "businessActivityInBuilding",
  typeOfActivity = "typeOfActivity",
  partOfFarm = "partOfFarm",
  additionalProtections = "additionalProtections",
  numberOfDamagesInLastThreeYears = "numberOfDamagesInLastThreeYears",
  claimlessYearsIn5Years = "claimlessYearsIn5Years",
  policyDuration = "policyDuration",
  startDate = "startDate",
  paymentMode = "paymentMode"
}

export interface AdditionalQuestionsModel {
  [AdditionalQuestionsId.businessActivityInBuilding]: BusinessActivityModel;
  [AdditionalQuestionsId.typeOfActivity]: TypeOfActivityId;
  [AdditionalQuestionsId.partOfFarm]: PartOfFarmModel;
  [AdditionalQuestionsId.additionalProtections]: AdditionalProtectionsModel;
  [AdditionalQuestionsId.numberOfDamagesInLastThreeYears]?: NumberOfDamagesInLastThreeYearsModel;
  [AdditionalQuestionsId.claimlessYearsIn5Years]?: ClaimlessYearsIn5YearsModel;
  [AdditionalQuestionsId.policyDuration]: PolicyDurationModel;
  [AdditionalQuestionsId.startDate]: Date;
  [AdditionalQuestionsId.paymentMode]: PaymentModeModel;
}

export class DefaultAdditionalQuestions implements AdditionalQuestionsModel {
  @observable businessActivityInBuilding: BusinessActivityModel;
  @observable typeOfActivity: TypeOfActivityId;
  @observable partOfFarm: PartOfFarmModel;
  @observable additionalProtections: AdditionalProtectionsModel;
  @observable numberOfDamagesInLastThreeYears: NumberOfDamagesInLastThreeYearsModel;
  @observable claimlessYearsIn5Years: ClaimlessYearsIn5YearsModel;
  @observable policyDuration: PolicyDurationModel;
  @observable startDate: Date;
  @observable paymentMode: PaymentModeModel;

  constructor() {
    makeObservable(this);

    this.typeOfActivity = TypeOfActivityId.registered;
    this.partOfFarm = new DefaultPartOfFarm(undefined);
    this.numberOfDamagesInLastThreeYears = new DefaultNumberOfDamagesInLastThreeYears(undefined);
    this.businessActivityInBuilding = new DefaultBusinessActivityInBuilding(undefined);
    this.claimlessYearsIn5Years = new DefaultClaimlessYearsIn5Years(undefined);
    this.additionalProtections = DefaultAdditionalProtections;
    this.policyDuration = new DefaultPolicyDuration(PolicyDurationId.MONTHS_12);
    this.paymentMode = new DefaultPaymentMode(PaymentModeId.oneTime);
    this.startDate = addDays(new Date(), 1);
  }
}
